import { gql, useQuery } from "@apollo/client";

export const CreateMachine = gql`
	mutation CreateMachine(
		$name: String!
		$avatar: String
		$serialNumber: String
		$category: String
		$ref:String
	) {
		createMachine(
			createMachineInput: {
	            ref: $ref
				name: $name
				photo: $avatar
				serialNumber: $serialNumber
				category: $category
			}
		) {
			_id
			name
			photo
		}
	}
`;
